import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-thongke-title',
  templateUrl: './thongke-title.component.html',
  styleUrls: ['./thongke-title.component.css']
})
export class ThongkeTitleComponent implements OnInit {
  @Input() numberCount = '0';
  @Input() colorNumber = '#1174c0';
  @Input() title = 'No title';
  @Input() font_size = '30px';
  constructor() { }

  ngOnInit(): void {
  }

}
